// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/dealer-delivery/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/dealer-delivery/")({
  component: PageComponent,

})

function PageComponent() {
  return <Page />
}
